module.exports = "https://static.wanderu.com/ui-react/_next/static/media/homescreen-iphone.85799bda.png";